<template>
    <div>
        <template v-if="displayBtnSkip">
            <div class="text-center mt-4">
                <button type="button" class="btn px-4" :disabled="!isReady" :class="isReady ? 'btn-info' : 'btn-secondary'" @click="onSkip">
                    {{ inforDataLottery?.extension?.btn_skip || '抽選結果を確認する' }}
                </button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'FormBSeriaLottery',
    props: {
        inforDataLottery: {
            type: Object,
            default: null
        },
        settingDesign: {
            type: Object,
            default: null
        }
    },
    computed: {
        redirectTime() {
            const timeRedirect = this.inforDataLottery?.extension?.automatic_redirect_after;
            return timeRedirect ? Number(timeRedirect) : null;
        },
        displayBtnSkip() {
            return this.inforDataLottery?.extension?.display_btn_skip;
        }
    },
    data() {
        return {
            isReady: false
        };
    },
    methods: {
        onSkip() {
            this.$emit('skipRedirect');
        }
    },
    mounted() {
        const timeDelay = this.redirectTime ? this.redirectTime * 1000 : 1000;
        setTimeout(() => {
            if (this.displayBtnSkip) {
                this.isReady = true;
            } else {
                this.onSkip();
            }
        }, timeDelay);
    }
};
</script>

<style lang="scss" scoped></style>
